<template>
  <div class="user-visit">

  <div>

  </div>
  </div>
</template>

<script>
export default {
  name: "UserVisit",
  props: {
    userVisit: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "UserVisit";
</style>
